<span class="loader {{ size }} {{ colorMode }}"></span>
